import { ReactNode } from 'react';

interface MainContentProps {
  children: ReactNode;
  className?: string;
}

export function MainContent({ children, className = '' }: MainContentProps) {
  return (
    <main
      className={`flex-1 overflow-y-auto px-4 py-6 sm:px-6 lg:px-8 ${className}`}
      role="main"
    >
      <div className="max-w-7xl mx-auto space-y-6">
        {children}
      </div>
    </main>
  );
}
